import React from 'react'
import { Stamp, ZeroKm } from './style'

export default () => (
  <Stamp>
    <ZeroKm />
  </Stamp>
)
